import React from 'react';
import { withRouter } from 'react-router-dom';
import IconDetail from './IconDetail';
import { RichText } from 'prismic-reactjs';
import { linkResolver } from '../../prismic-configurations';

let WorkshopCard = withRouter((props) => {
  const { uid, tags, data, history } = props;
  const {
    title,
    description,
    date,
    cost,
    duration,
    location,
    status,
    image
  } = data;

  const isRegistrationOpen = status && status === 'Registration Open';

  return (
    <div className="workshop__card card">
      <div onClick={() => history.push(`/workshop/${uid}`)}>
        <div className="img-container">
          {image?.url && <img src={image.url} alt={title} />}
        </div>
        <div className="tags-top">
          <span className="duration-tag">{duration}</span>
          <span className="topic-tag">{tags[0]}</span>
        </div>
        <div className="workshop__card-details">
          <div className="title">
            <h2>{title[0].text}</h2>
          </div>
          <RichText
            Component="div"
            className="description"
            render={description}
            linkResolver={linkResolver}
          />

          <IconDetail type="date" value={date} />
          <IconDetail type="cost" value={cost} />
        </div>
        <div className="tags-bottom">
          <span className="venue-tag">{location}</span>
          <span
            className={`registration-tag ${
              isRegistrationOpen ? 'open' : 'closed'
            }`}
          >
            {status}
          </span>
        </div>
      </div>
    </div>
  );
});

export default WorkshopCard;
